import { render } from "./PPTPlayer.vue?vue&type=template&id=06203cb5&scoped=true"
import script from "./PPTPlayer.vue?vue&type=script&lang=js"
export * from "./PPTPlayer.vue?vue&type=script&lang=js"

import "./PPTPlayer.vue?vue&type=style&index=0&id=06203cb5&scoped=true&lang=css"

import exportComponent from "C:\\Project\\VuePro\\guifanrenrenxing\\guifanrenrenxing-index\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06203cb5"]])

export default __exports__